import { combineEpicsAndCatchErrors } from "../../../../generic/redux/CombineEpicsAndCatchErrors";

import { StackPacksApiEpic } from "./StackPacksApiEpic";
import { StackPacksDeprovisionEpic } from "./StackPacksDeprovisionEpic";
import { StackPacksProvisionEpic } from "./StackPacksProvisionEpic";
import { StatusUpdateStreamEpic } from "./StackPacksStatusUpdateStreamEpic";
import { StackPacksUpgradeEpic } from "./StackPackUpgradeEpic";

export const StackPacksEpic = combineEpicsAndCatchErrors(
	StackPacksApiEpic,
	StackPacksProvisionEpic,
	StackPacksDeprovisionEpic,
	StatusUpdateStreamEpic,
	StackPacksUpgradeEpic,
);
